"use client";

import { motion } from "motion/react";
import type { ReactNode } from "react";
import {
  MotionSection,
  usePressedInteraction,
} from "@/components/ui/motion-primitives";

interface LocationAnimatedCardProps {
  readonly children: ReactNode;
}

export function LocationAnimatedCard({ children }: LocationAnimatedCardProps) {
  return <MotionSection>{children}</MotionSection>;
}

export function LocationPulseCTA({ children }: LocationAnimatedCardProps) {
  const interaction = usePressedInteraction();

  return (
    <motion.div
      className="inline-flex"
      {...interaction}
    >
      {children}
    </motion.div>
  );
}
